var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarLogoTxt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 30,
    viewBox: "0 0 168 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.571999 29.2245L0 28.6555V0.927467L0.571999 0.355469H6.409L6.981 0.927467V17.3555H19.128V0.927467L19.7 0.355469H25.537L26.109 0.927467V28.6555L25.537 29.2275H19.7L19.128 28.6555V17.9845H6.981V28.6555L6.409 29.2275H0.571999V29.2245Z",
    fill: "#807CE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0965 0.355469H62.1755L67.8155 11.1225L73.4555 0.355469H80.4955L81.0675 0.927467L71.3265 16.3085V28.6555L70.7155 29.2275H64.9155L64.3435 28.6555V16.3085L54.5635 0.927467L55.0965 0.355469Z",
    fill: "#807CE0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7851 29.2245H84.4011L83.8291 28.6525V0.927467L84.4011 0.355469H96.7851C104.771 0.355469 109.563 6.42947 109.563 14.7905C109.563 23.1715 104.712 29.2255 96.7851 29.2255V29.2245ZM90.8101 23.7425H93.7291C98.5801 23.7425 102.563 21.1785 102.563 14.7895C102.563 8.40047 98.4021 5.83646 93.7291 5.83646H90.8111V23.7415L90.8101 23.7425Z",
    fill: "#807CE0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112.027 14.809C112.027 6.30901 116.878 0 125.673 0C134.468 0 139.319 6.27101 139.319 14.809C139.319 23.347 134.429 29.579 125.673 29.579C116.917 29.579 112.027 23.269 112.027 14.809ZM125.693 24.097C129.676 24.097 132.358 21.04 132.358 14.809C132.358 8.57801 129.858 5.48199 125.693 5.48199C121.528 5.48199 119.028 8.65701 119.028 14.809C119.028 20.961 121.527 24.1 125.693 24.1V24.097Z",
    fill: "#807CE0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M160.969 28.6555L149.65 4.43946V28.6555L149.078 29.2275H143.278L142.667 28.6555V0.927467L143.278 0.355469H148.169L148.78 0.927467L160.336 25.4785V0.927467L160.908 0.355469H166.745L167.317 0.927467V28.6555L166.745 29.2275H161.539L160.967 28.6555H160.969Z",
    fill: "#807CE0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.3657 17.3554L43.5207 9.01443L46.7157 17.3554H40.3657ZM40.1287 17.9864L36.1067 28.6554L35.5347 29.2274H29.5007L28.9287 28.6554L40.4647 0.811424L41.1157 0.357422H46.0057L46.6567 0.811424L58.2117 28.6554L57.6397 29.2274H51.6057L51.0337 28.6554L46.9517 17.9874L40.1287 17.9864Z",
    fill: "#807CE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarLogoTxt);
export default __webpack_public_path__ + "static/media/sidebar-logo-txt.5cf7dcacbbe3649da691babb9669fca3.svg";
export { ForwardRef as ReactComponent };